import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { slot: "dialog-header" }
const _hoisted_2 = { slot: "dialog-subheader" }

import {ref} from 'vue';
    import {useTranslation} from '@malt/vue3-use/src/core/useTranslation';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'EducationDeleteDialog',
  setup(__props) {

    const educationDeleteDialog = ref(null);
    const {msg} = useTranslation();

    function handleConfirm() {
        educationDeleteDialog.value!.open = false;
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_dialog = _resolveComponent("joy-dialog")!

  return (_openBlock(), _createBlock(_component_joy_dialog, {
    id: "educationDeleteDialog",
    ref_key: "educationDeleteDialog",
    ref: educationDeleteDialog,
    "confirm-text": _unref(msg)('generic.form.confirm.label'),
    "cancel-text": _unref(msg)('generic.form.cancel.label'),
    onJoyConfirmDialog: handleConfirm
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.education.delete.confirm.title')), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.education.delete.confirm.description')), 1)
    ]),
    _: 1
  }, 8, ["confirm-text", "cancel-text"]))
}
}

})